import React, { Component } from 'react';
//import Spinner from 'react-spinkit'; http://tobiasahlin.com/spinkit/
// import './indicator.css';
import PropTypes from 'prop-types';
import { AppSettings } from '../../constants';

export class Indicator extends Component {
  static propTypes = {
    show: PropTypes.bool,
    id: PropTypes.string
  };
  constructor(props) {
    super(props);
  }

  render() {
    let isSSOUser = localStorage[AppSettings.IS_SSO_USER];
    console.log('path name',window.location.pathname, isSSOUser)
    if (this.props.show) {
      return (
        <div id={this.props.id} className='cls-indicator'>
          <div className={window.location.pathname==='/authenticate' || isSSOUser === 'True' || isSSOUser === true?'spinnerSSO':'spinner'}>
            <div className='bounce1' />
            <div className='bounce2' />
            <div className='bounce3' />
          </div>
        </div>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/indicators/indicator.js